"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var spotify_1 = require("../spotify");
var styles_1 = require("../styles");
var ClickOutside_1 = __importDefault(require("./ClickOutside"));
var Devices_1 = __importDefault(require("./icons/Devices"));
var Wrapper = styles_1.styled('div')({
    position: 'relative',
    zIndex: 20,
    '> div': {
        bottom: '120%',
        display: 'flex',
        flexDirection: 'column',
        padding: styles_1.px(8),
        position: 'absolute',
        right: "-" + styles_1.px(3),
        button: {
            display: 'block',
            padding: styles_1.px(8),
            whiteSpace: 'nowrap',
            '&.rswp__devices__active': {
                fontWeight: 'bold',
            },
        },
    },
    '> button': {
        fontSize: styles_1.px(26),
    },
}, function (_a) {
    var styles = _a.styles;
    return ({
        '> button': {
            color: styles.color,
        },
        '> div': {
            backgroundColor: styles.bgColor,
            boxShadow: styles.altColor ? "1px 1px 10px " + styles.altColor : 'none',
            button: {
                color: styles.color,
            },
        },
    });
}, 'DevicesRSWP');
var Devices = (function (_super) {
    __extends(Devices, _super);
    function Devices(props) {
        var _this = _super.call(this, props) || this;
        _this._isMounted = false;
        _this.handleClickSetDevice = function (e) {
            var _a = _this.props, onClickDevice = _a.onClickDevice, token = _a.token;
            var dataset = e.currentTarget.dataset;
            if (dataset.id) {
                onClickDevice(dataset.id);
                spotify_1.setDevice(dataset.id, token);
                _this.setState({ isOpen: false });
            }
        };
        _this.handleClickToggleDevices = function () {
            _this.setState(function (state) { return ({ isOpen: !state.isOpen }); });
        };
        _this.state = {
            devices: [],
            isOpen: props.open,
        };
        return _this;
    }
    Devices.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var token, devices, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this._isMounted = true;
                        token = this.props.token;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4, spotify_1.getDevices(token)];
                    case 2:
                        devices = (_a.sent()).devices;
                        if (this._isMounted) {
                            this.setState({ devices: devices || [] });
                        }
                        return [3, 4];
                    case 3:
                        error_1 = _a.sent();
                        console.error('getDevices', error_1);
                        return [3, 4];
                    case 4: return [2];
                }
            });
        });
    };
    Devices.prototype.componentWillUnmount = function () {
        this._isMounted = false;
    };
    Devices.prototype.render = function () {
        var _this = this;
        var _a = this.state, devices = _a.devices, isOpen = _a.isOpen;
        var _b = this.props, deviceId = _b.deviceId, styles = _b.styles;
        return (react_1.default.createElement(Wrapper, { styles: styles }, !!devices.length && (react_1.default.createElement(react_1.default.Fragment, null,
            isOpen && (react_1.default.createElement(ClickOutside_1.default, { onClick: this.handleClickToggleDevices }, devices.map(function (d) { return (react_1.default.createElement("button", { key: d.id, className: d.id === deviceId ? 'rswp__devices__active' : undefined, "data-id": d.id, onClick: _this.handleClickSetDevice, type: "button" }, d.name)); }))),
            react_1.default.createElement("button", { type: "button", onClick: this.handleClickToggleDevices },
                react_1.default.createElement(Devices_1.default, null))))));
    };
    return Devices;
}(react_1.PureComponent));
exports.default = Devices;
